import React, { FC } from 'react';
import styled from 'styled-components';

import { ReactComponent as StripeLogo } from '@/assets/stripe-logo.svg';

/**
 * Znak Stripe w fioletowym kwadracie — tak, jak wygląda jego oficjalne logo.
 *
 * Sam znak w kolorze marki gubił się w kolumnie ikon: reszta sidebara to kreski
 * o jednakowej grubości, a litera „S" bez tła czytała się jak przypadkowy kształt.
 * Kafelek daje jej te same wymiary co pozostałym ikonom i od razu mówi, o czyją
 * integrację chodzi.
 */

const Tile = styled.span<{ $size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: ${({ $size }) => Math.round($size * 0.28)}px;
  background: #635bff;

  /* Podwojony selektor (&&) podbija swoistość: kafelek integracji w ustawieniach
     rozciąga każdą ikonę do 100% swojego pudełka, a tu wewnętrzny znak ma zostać
     mniejszy od fioletowego kwadratu. */
  && svg {
    /* Znak zajmuje ok. 60% kafelka: przy pełnej szerokości dotykałby krawędzi,
       a logo Stripe ma wyraźny margines wokół litery. */
    width: ${({ $size }) => Math.round($size * 0.6)}px;
    height: ${({ $size }) => Math.round($size * 0.6)}px;
    display: block;

    /* FILL, NIE COLOR. Sidebar przestawia ikonom kolor przy hoverze i na pozycji
       aktywnej, a znak Stripe wypełnia się przez currentColor, więc razem z resztą ikon
       robił się czarny albo biały zależnie od stanu. Jawny fill jest odporny na tamte
       reguły (CSS wygrywa z atrybutem prezentacyjnym), więc litera zostaje biała zawsze. */
    fill: #ffffff;
  }
`;

interface StripeTileIconProps {
  /** Bok kafelka w px — sidebar podaje tu ten sam rozmiar co pozostałym ikonom. */
  size?: number;
}

export const StripeTileIcon: FC<StripeTileIconProps> = ({ size = 18 }) => (
  <Tile $size={size} aria-hidden>
    <StripeLogo />
  </Tile>
);
